//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FollowRules',
  props: {
    formData: {
      default: function _default() {},
      type: Object
    }
  },
  data: function data() {
    return {
      grid1: {
        xl: 2,
        lg: 4,
        md: 2,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 20,
        lg: 18,
        md: 20,
        sm: 24,
        xs: 24
      },
      rules: {
        unsettled_cycle: [{
          required: true,
          message: '请输入退回客户公海周期'
        }],
        advance_cycle: [{
          required: true,
          validator: this.checkAdvanceCycle
        }],
        unsettled_client_number: [{
          required: true,
          message: '请输入未成交客户数量'
        }],
        unfollowed_cycle: [{
          required: true,
          message: '请输入未跟进退回公海数量'
        }]
      }
    };
  },
  watch: {
    'formData.unsettled_cycle': function formDataUnsettled_cycle(newValue, oldValue) {
      if (newValue === '') {
        return;
      }
      var numericValue = parseInt(newValue, 10);
      if (isNaN(numericValue)) {
        this.formData.unsettled_cycle = oldValue || '';
      } else {
        this.formData.unsettled_cycle = Math.abs(numericValue).toString();
      }
    },
    'formData.advance_cycle': function formDataAdvance_cycle(newValue, oldValue) {
      if (newValue === '') {
        return;
      }
      var numericValue = parseInt(newValue, 10);
      if (isNaN(numericValue)) {
        this.formData.advance_cycle = oldValue || '';
      } else {
        this.formData.advance_cycle = Math.abs(numericValue).toString();
      }
    },
    'formData.unsettled_client_number': function formDataUnsettled_client_number(newValue, oldValue) {
      if (newValue === '') {
        return;
      }
      var numericValue = parseInt(newValue, 10);
      if (isNaN(numericValue)) {
        this.formData.unsettled_client_number = oldValue || '';
      } else {
        this.formData.unsettled_client_number = Math.abs(numericValue).toString();
      }
    }
  },
  methods: {
    sendReturnData: function sendReturnData() {
      var data = this.formData;
      this.$emit('returnData', data);
    },
    saveEvt: function saveEvt() {
      this.$emit('saveEvt');
    },
    checkAdvanceCycle: function checkAdvanceCycle(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入客户退回公海提醒提前天数'));
      } else if (parseInt(value, 10) >= parseInt(this.formData.unsettled_cycle, 10) || parseInt(value, 10) >= parseInt(this.formData.unfollowed_cycle, 10)) {
        callback(new Error('退回公海提醒天数要小于未成交退回天数和未跟进退回天数'));
      } else {
        callback();
      }
    }
  }
};